{
  "previous": "Sebelumnya",
  "next": "Seterusnya",
  "complete": "Selesai",
  "verifyAndCheckIn": "Sahkan dan daftar masuk",
  "loading": {
    "retrievingLocation": "Mendapatkan lokasi...",
    "retrievingWarehouse": "Mendapatkan data gudang..."
  },
  "validation": {
    "fieldRequired": "Ruangan ini diperlukan",
    "fieldRequiredWithLabel": "{label} diperlukan",
    "phoneInvalid": "Ini bukan nombor telefon yang sah",
    "phoneInvalidWithExample": "Ini bukan nombor telefon yang sah (contoh: {example})"
  }
}
